const ACCESS_TOKEN_KEY = 'trinity_access_token';
const REFRESH_TOKEN_KEY = 'trinity_refresh_token';

/** Legacy tab-scoped storage; migrated once into localStorage. */
const LEGACY_ACCESS_KEY = ACCESS_TOKEN_KEY;
const LEGACY_REFRESH_KEY = REFRESH_TOKEN_KEY;

function migrateFromSessionStorage() {
  if (typeof globalThis.window === 'undefined') return;

  const legacyAccess = globalThis.sessionStorage.getItem(LEGACY_ACCESS_KEY);
  const legacyRefresh = globalThis.sessionStorage.getItem(LEGACY_REFRESH_KEY);
  if (!legacyAccess && !legacyRefresh) return;

  if (legacyAccess && !globalThis.localStorage.getItem(ACCESS_TOKEN_KEY)) {
    globalThis.localStorage.setItem(ACCESS_TOKEN_KEY, legacyAccess);
  }
  if (legacyRefresh && !globalThis.localStorage.getItem(REFRESH_TOKEN_KEY)) {
    globalThis.localStorage.setItem(REFRESH_TOKEN_KEY, legacyRefresh);
  }

  globalThis.sessionStorage.removeItem(LEGACY_ACCESS_KEY);
  globalThis.sessionStorage.removeItem(LEGACY_REFRESH_KEY);
}

export function saveTokens(accessToken: string, refreshToken: string) {
  migrateFromSessionStorage();
  globalThis.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  globalThis.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function clearTokens() {
  globalThis.localStorage.removeItem(ACCESS_TOKEN_KEY);
  globalThis.localStorage.removeItem(REFRESH_TOKEN_KEY);
  globalThis.sessionStorage.removeItem(LEGACY_ACCESS_KEY);
  globalThis.sessionStorage.removeItem(LEGACY_REFRESH_KEY);
}

export function getStoredAccessToken(): string | null {
  migrateFromSessionStorage();
  return globalThis.localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getStoredRefreshToken(): string | null {
  migrateFromSessionStorage();
  return globalThis.localStorage.getItem(REFRESH_TOKEN_KEY);
}
